import { Link } from "react-router-dom";
import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss";
import RequestTable from "./RequestTable";
import { useState } from "react"
import { ROLES } from "../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../hooks/app";
import { getUser } from "../../../../store/slices/auth-slice";
import { getAllRequestSignatures, getRequestSignaturesFromApi } from "../../../../store/slices/request-signature.slice";
import { useEffect } from "react"
import { Toaster } from "react-hot-toast";
function RequestSignature() {

  const user = useAppSelector(getUser)

  const data = useAppSelector(getAllRequestSignatures)
  const [perPage, setPerPage] = useState(10)
  const [page, setPage] = useState(1)

  const dispatch = useAppDispatch()

  const handlePerRowsChange = async (newPerPage: number) => {
    setPerPage(newPerPage)
  }
  const handlePageChange = (page: number) => {
    setPage(page)
  }

  useEffect(() => {
    dispatch(getRequestSignaturesFromApi({ page, per_page: perPage }))
  }, [dispatch, page, perPage])

  return (
    <LayoutProvider classNames="request_signature_page">
      <Toaster />
      <h2 className="heading2">Request Signatures</h2>
      {user?.role === ROLES.STUDENT ? <div className="alert__card">
        <div className="row">
          <div className="col col-lg-6">
            <h3 className="heading3">Send Signature Request</h3>
            <p className="text">
              Pilots Logbook provides facilities for an instructor to sign a
              logbook on another pilot's behalf, with that pilot's permission.
              While every attempt is made to ensure the integrity of this
              process, it has not been vetted by the FAA or other similar
              agencies, and may therefore not be acceptable to these agencies.
            </p>
          </div>
          <div className="col col-lg-6 d-flex flex-column align-items-md-end gap-2">
            <Link to={"/training/request-signatures/create"}>
              <button className="button">Request Now</button>
            </Link>
            <p className="text">Go to request form section.</p>
          </div>
        </div>
      </div> : null}

      {user?.role === ROLES.STUDENT ? <>
        <h3 className="heading3 my-4">Send Signature Request</h3>
        <RequestTable handlePerRowsChange={handlePerRowsChange} handlePageChange={handlePageChange} data={data} instructor={true} />
      </> : null}

      {user?.role === ROLES.INSTRUCTOR ? <><h3 className="heading3 my-4 mt-5">Received Signature Request</h3>
        <RequestTable handlePerRowsChange={handlePerRowsChange} handlePageChange={handlePageChange} data={data} instructor={false} />
      </> : null}
    </LayoutProvider>
  );
}

export default RequestSignature;
